import { render, staticRenderFns } from "./carving.vue?vue&type=template&id=1dfdd783&scoped=true"
import script from "./carving.vue?vue&type=script&lang=js"
export * from "./carving.vue?vue&type=script&lang=js"
import style0 from "./carving.vue?vue&type=style&index=0&id=1dfdd783&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfdd783",
  null
  
)

export default component.exports